import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Account Holder Information", -1)

import { computed } from "vue";
import * as rules from "@/utils/rules";
import states from "@/constants/stateOptions";
import DateInput from "../custom/DateInput.vue";
import FsaVariables from "@/types/FsaVariables";
import FsaProvider from "@/types/FsaProvider";
import FormTItle from "../common/FormTItle.vue";
import TextInput from "../custom/TextInput.vue";
import PhoneNumberInput from "../custom/PhoneNumberInput.vue";
import SelectInput from "../custom/SelectInput.vue";
import ZipCodeInput from "../custom/ZipCodeInput.vue";
import CustomRadioGroup from "../custom/CustomRadioGroup.vue";

type ProviderOption = {
  value: string;
  title: string;
  image: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'InsuranceInformationForm',
  props: {
    modelValue: {},
    providers: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const variables = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const isAccountHolderQuestion = `Is ${variables.value.firstName} ${variables.value.lastName} the primary account holder?`;
const relationshipQuestion = `What is ${variables.value.firstName} ${variables.value.lastName}'s relationship to the account holder?`;

const selectedProvider = computed(() =>
  props.providers.find(
    (provider) => provider.name === variables.value.planAdministrator
  )
);

// We map into the format that the v-autocomplete component expects
const providerOptions = computed((): ProviderOption[] =>
  props.providers
    .filter((provider) => !!provider.workflow)
    .map((provider) => ({
      value: provider.name,
      title: provider.name,
      image: provider.image,
    }))
);

const formOptions = computed(() => selectedProvider.value?.formOptions || {});

// To do: Maybe move account holder info to another variable
function clearAccountHolderInfo() {
  variables.value.accountHolderLastName = undefined;
  variables.value.accountHolderFirstName = undefined;
  variables.value.accountHolderMiddleInitial = undefined;
  variables.value.accountHolderDateOfBirth = undefined;
  variables.value.accountHolderAddressState = undefined;
  variables.value.accountHolderAddressCity = undefined;
  variables.value.accountHolderAddressZip = undefined;
  variables.value.accountHolderAddressStreet = undefined;
  variables.value.accountHolderAddressStreet2 = undefined;
  variables.value.accountHolderEmail = undefined;
  variables.value.accountHolderPhoneNumber = undefined;
}

function setUserInfoToAccountHolder() {
  variables.value.accountHolderLastName = variables.value.lastName;
  variables.value.accountHolderFirstName = variables.value.firstName;
  variables.value.accountHolderMiddleInitial = variables.value.middleInitial;
  variables.value.accountHolderDateOfBirth = variables.value.dateOfBirth;
  variables.value.accountHolderAddressState = variables.value.addressState;
  variables.value.accountHolderAddressCity = variables.value.addressCity;
  variables.value.accountHolderAddressZip = variables.value.addressZip;
  variables.value.accountHolderAddressStreet = variables.value.addressStreet;
  variables.value.accountHolderAddressStreet2 = variables.value.addressStreet2;
  variables.value.accountHolderEmail = variables.value.email;
  variables.value.accountHolderPhoneNumber = variables.value.phoneNumber;
}

function onChangeAccountHolderOption() {
  if (variables.value.isAccountHolder) {
    setUserInfoToAccountHolder();
  } else {
    clearAccountHolderInfo();
  }
}

function onChangeRelationshipOption() {
  variables.value.relationshipToAccountHolder =
    variables.value.relationshipOption !== "Other"
      ? variables.value.relationshipOption
      : undefined;

  variables.value.isChildFullTimeStudent = undefined;
  variables.value.schoolName = undefined;
  variables.value.isChildPhysicallyImpaired = undefined;
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(FormTItle, {
            title: "Insurance information",
            description: "Give us some information about your FSA provider"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "7",
        class: "pb-0 pt-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_autocomplete, {
            "bg-color": '#FAFBFC',
            items: providerOptions.value,
            label: "FSA Plan Administrator",
            "menu-icon": "",
            readonly: "",
            "append-inner-icon": "mdi-magnify",
            variant: "outlined",
            modelValue: variables.value.planAdministrator,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((variables.value.planAdministrator) = $event)),
            rules: [rules.requiredRule]
          }, {
            chip: _withCtx(({ item }) => [
              _createVNode(_component_v_chip, {
                class: "avatar-chip v-avatar",
                variant: "text",
                "prepend-avatar": item?.raw?.image,
                text: item.raw.title
              }, null, 8, ["prepend-avatar", "text"])
            ]),
            item: _withCtx(({ props, item }) => [
              _createVNode(_component_v_list_item, _mergeProps({ class: "custom-avatar" }, props, {
                "prepend-avatar": item?.raw?.image
              }), null, 16, ["prepend-avatar"])
            ]),
            _: 1
          }, 8, ["items", "modelValue", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "5",
        class: "pb-0 pt-5"
      }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            "bg-color": '#FAFBFC',
            variant: "outlined",
            label: "Member ID or Account Number",
            modelValue: variables.value.memberId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((variables.value.memberId) = $event)),
            rules: [rules.requiredRule],
            required: ""
          }, null, 8, ["modelValue", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "pa-4",
            variant: "outlined",
            style: {"background":"#fafbfc !important"}
          }, {
            default: _withCtx(() => [
              _createVNode(CustomRadioGroup, {
                label: "Are you the primary account holder?",
                label2: isAccountHolderQuestion,
                modelValue: variables.value.isAccountHolder,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((variables.value.isAccountHolder) = $event)),
                rules: [rules.requiredRule],
                onChange: onChangeAccountHolderOption,
                options: [
            {
              label: 'Yes, the insurance plan is in my name.',
              value: true,
            },
            {
              label: 'No, the insurance plan belongs to a family member.',
              value: false,
            },
          ],
                required: "",
                isInsurance: true
              }, null, 8, ["modelValue", "rules", "options"]),
              (variables.value.isAccountHolder == false)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(CustomRadioGroup, {
                      label: "Relationship to account holder",
                      label2: relationshipQuestion,
                      modelValue: variables.value.relationshipOption,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((variables.value.relationshipOption) = $event)),
                      onChange: onChangeRelationshipOption,
                      rules: [rules.requiredRule],
                      options: [
              {
                label: 'Spouse/Partner',
                value: 'Spouse/Partner',
              },
              {
                label: 'Child',
                value: 'Child',
              },
              {
                label: 'Other',
                value: 'Other',
              },
            ],
                      required: "",
                      isInsurance: true
                    }, null, 8, ["modelValue", "rules"]),
                    (variables.value.relationshipOption == 'Other')
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: 6
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TextInput, {
                              variant: "outlined",
                              label: "Enter your relationship to account holder",
                              modelValue: variables.value.relationshipToAccountHolder,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((variables.value.relationshipToAccountHolder) = $event)),
                              rules: [rules.requiredRule],
                              required: ""
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (variables.value.isAccountHolder === false)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  "bg-color": '#FAFBFC',
                  variant: "outlined",
                  label: "First name",
                  modelValue: variables.value.accountHolderFirstName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((variables.value.accountHolderFirstName) = $event)),
                  rules: [rules.requiredRule],
                  required: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  "bg-color": '#FAFBFC',
                  variant: "outlined",
                  label: "Last name",
                  modelValue: variables.value.accountHolderLastName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((variables.value.accountHolderLastName) = $event)),
                  rules: [rules.requiredRule],
                  required: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  "bg-color": '#FAFBFC',
                  variant: "outlined",
                  label: "Middle initial (optional)",
                  modelValue: variables.value.accountHolderMiddleInitial,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((variables.value.accountHolderMiddleInitial) = $event)),
                  rules: [rules.middleInitialRule]
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  "bg-color": '#FAFBFC',
                  variant: "outlined",
                  label: "Email address",
                  modelValue: variables.value.accountHolderEmail,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((variables.value.accountHolderEmail) = $event)),
                  rules: [rules.requiredRule, rules.emailRule],
                  required: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(PhoneNumberInput, {
                  modelValue: variables.value.accountHolderPhoneNumber,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((variables.value.accountHolderPhoneNumber) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(DateInput, {
                  "bg-color": '#FAFBFC',
                  variant: "outlined",
                  label: "Date of Birth",
                  modelValue: variables.value.accountHolderDateOfBirth,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((variables.value.accountHolderDateOfBirth) = $event)),
                  rules: [rules.requiredRule]
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  "bg-color": '#FAFBFC',
                  variant: "outlined",
                  label: "Street Address",
                  modelValue: variables.value.accountHolderAddressStreet,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((variables.value.accountHolderAddressStreet) = $event)),
                  rules: [rules.requiredRule],
                  required: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  "bg-color": '#FAFBFC',
                  variant: "outlined",
                  label: "Street Address 2",
                  modelValue: variables.value.accountHolderAddressStreet2,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((variables.value.accountHolderAddressStreet2) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(TextInput, {
                  "bg-color": '#FAFBFC',
                  variant: "outlined",
                  label: "City",
                  modelValue: variables.value.accountHolderAddressCity,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((variables.value.accountHolderAddressCity) = $event)),
                  rules: [rules.requiredRule],
                  required: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(SelectInput, {
                  "bg-color": '#FAFBFC',
                  items: _unref(states),
                  variant: "outlined",
                  label: "State",
                  modelValue: variables.value.accountHolderAddressState,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((variables.value.accountHolderAddressState) = $event)),
                  rules: [rules.requiredRule],
                  required: ""
                }, null, 8, ["items", "modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(ZipCodeInput, {
                  label: "ZIP",
                  modelValue: variables.value.accountHolderAddressZip,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((variables.value.accountHolderAddressZip) = $event)),
                  rules: [rules.requiredRule, rules.zipCodeRule],
                  required: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            "bg-color": '#FAFBFC',
            variant: "outlined",
            label: "Employer/Company Name",
            modelValue: variables.value.employerOrCompanyName,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((variables.value.employerOrCompanyName) = $event)),
            rules: [rules.requiredRule],
            required: ""
          }, null, 8, ["modelValue", "rules"])
        ]),
        _: 1
      }),
      (formOptions.value.last4DigitsOfSSN)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 1,
            cols: "12",
            sm: "12",
            md: "6",
            lg: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(TextInput, {
                "bg-color": '#FAFBFC',
                variant: "outlined",
                label: "Last 4 Digits of SSN",
                modelValue: variables.value.last4DigitsOfSSN,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((variables.value.last4DigitsOfSSN) = $event)),
                rules: [rules.requiredRule, rules.last4DigitsOfSSNRule],
                required: ""
              }, null, 8, ["modelValue", "rules"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (formOptions.value.socialSecurityNumber)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 2,
            cols: "12",
            sm: "12",
            md: "6",
            lg: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(TextInput, {
                "bg-color": '#FAFBFC',
                variant: "outlined",
                label: "Social Security Number",
                modelValue: variables.value.socialSecurityNumber,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((variables.value.socialSecurityNumber) = $event)),
                rules: [rules.requiredRule, rules.socialSecurityNumberRule],
                required: ""
              }, null, 8, ["modelValue", "rules"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (formOptions.value.employeeId)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 3,
            cols: "12",
            sm: "12",
            md: "6",
            lg: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(TextInput, {
                "bg-color": '#FAFBFC',
                variant: "outlined",
                label: "Employee ID",
                modelValue: variables.value.employeeId,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((variables.value.employeeId) = $event)),
                rules: [rules.requiredRule],
                required: ""
              }, null, 8, ["modelValue", "rules"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})